import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from './apiClient';

const articleStockKeys = {
  all: ['articleStocks'],
  byArticle: (articleId) => [...articleStockKeys.all, 'byArticle', articleId],
};

export const useArticleStocksByArticle = (articleId, options = {}) => {
  return useQuery({
    queryKey: articleStockKeys.byArticle(articleId),
    queryFn: async () => {
      const response = await apiClient.get(`article_stocks/by-article/${articleId}`);
      return response.data;
    },
    enabled: !!articleId,
    staleTime: 60 * 1000,
    ...options,
  });
};

export const useAdjustArticleStock = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload) => {
      const response = await apiClient.post('article_stocks/adjust', payload);
      return response.data;
    },
    onSuccess: (_data, variables) => {
      if (variables?.uuid_inventory_article) {
        queryClient.invalidateQueries({
          queryKey: articleStockKeys.byArticle(variables.uuid_inventory_article),
        });
      }
      queryClient.invalidateQueries({ queryKey: ['stockMovements'] });
    },
    onError: (error) => {
      console.error('Error adjusting article stock:', error);
    },
  });
};
